import React from "react";
import { BsX } from "react-icons/bs";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import { cn } from "./utils/cn";

const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(function DialogContent({ className, children, ...props }, ref) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="grid place-items-center overflow-y-auto fixed inset-0 px-5 py-4 z-40 bg-black/5 backdrop-blur-sm backdrop-saturate-150 data-[state=open]:animate-overlay-show data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
        <DialogPrimitive.Content
          ref={ref}
          className={cn(
            "relative bg-white rounded-xl shadow-card z-50 grid gap-4 border bg-background p-5 duration-200",
            // "data-[state=open]:animate-content-show data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
            className
          )}
          {...props}
        >
          {children}
          <DialogPrimitive.Close className="absolute p-1 rounded-full bg-gray-100 right-4 top-4 opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-primary-2 data-[state=open]:text-muted-foreground">
            <BsX className="h-6 w-6" />
            <span className="sr-only">Fechar</span>
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Overlay>
    </DialogPrimitive.Portal>
  );
});

export const Dialog = Object.assign(DialogPrimitive.Root, {
  Content: DialogContent,
  Title: DialogPrimitive.Title,
  Description: DialogPrimitive.Description,
  Trigger: DialogPrimitive.Trigger,
  Close: DialogPrimitive.Close,
});
